/* eslint-disable */
import { loadFromStorage } from "./Auth";

/* ═══════════════════════════════════════════════════════════
   FOOTY ANALYST — EXPORT / PRINT SYSTEM
   Uses window.print() with print CSS — works offline, no library
   Professional printed output for coaches to share with staff
   Exports: Opposition Dossier · Match Prep · Session Plans · Squad
═══════════════════════════════════════════════════════════ */

/* ── Print CSS injected into a new window ── */
const PRINT_CSS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  @page { size: A4; margin: 14mm 16mm 14mm 16mm; }

  body {
    font-family: 'Arial', 'Helvetica', sans-serif;
    font-size: 10pt;
    color: #1a1612;
    background: white;
    line-height: 1.55;
  }

  /* Header */
  .print-header {
    display: flex; align-items: flex-start; justify-content: space-between;
    border-bottom: 3px solid #1a1612; padding-bottom: 8px; margin-bottom: 14px;
  }
  .print-brand { font-size: 7pt; font-weight: 800; letter-spacing: 3px; text-transform: uppercase; color: #2e7d7a; }
  .print-doc-title { font-size: 18pt; font-weight: 900; letter-spacing: 1px; text-transform: uppercase; line-height: 1; margin-top: 2px; }
  .print-doc-sub { font-size: 8.5pt; color: #666; margin-top: 3px; }
  .print-meta { text-align: right; font-size: 8pt; color: #666; }
  .print-meta strong { color: #1a1612; font-weight: 700; }

  /* Sections */
  .print-section { margin-bottom: 12px; break-inside: avoid; }
  .print-section-title {
    font-size: 8pt; font-weight: 800; letter-spacing: 3px; text-transform: uppercase;
    color: #2e7d7a; border-bottom: 1.5px solid #2e7d7a;
    padding-bottom: 2px; margin-bottom: 6px;
  }
  .print-section-title.dark {
    background: #1a1612; color: white; padding: 3px 6px; letter-spacing: 2px; border: none;
  }

  /* Two column layout */
  .print-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px; }
  .print-cols-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 12px; }

  /* Bullet lists */
  .print-list { padding: 0; list-style: none; }
  .print-list li {
    padding: 2.5px 0 2.5px 14px; position: relative;
    font-size: 9.5pt; border-bottom: 0.5px solid #eee;
  }
  .print-list li:last-child { border-bottom: none; }
  .print-list li::before { content: '→'; position: absolute; left: 0; color: #2e7d7a; font-weight: 800; }
  .print-list li.bullet::before { content: '•'; }
  .print-list li.number::before { content: attr(data-n); font-weight: 800; color: #1a1612; }
  .print-list li.danger::before { content: '⚠'; color: #8b2a2a; }
  .print-list li.check::before { content: '✓'; color: #16a34a; }
  .print-list li.cross::before { content: '✗'; color: #8b2a2a; }

  /* Cards */
  .print-card { border: 1.5px solid #ddd; padding: 7px 9px; break-inside: avoid; margin-bottom: 6px; }
  .print-card-title { font-weight: 800; font-size: 9.5pt; margin-bottom: 2px; }
  .print-card-sub { font-size: 8.5pt; color: #555; }
  .print-card.accent { border-left: 4px solid #2e7d7a; }
  .print-card.danger { border-left: 4px solid #8b2a2a; background: #fef2f2; }
  .print-card.warning { border-left: 4px solid #d4941a; background: #fffbeb; }
  .print-card.good { border-left: 4px solid #16a34a; background: #f0fdf4; }

  /* Threat badges */
  .print-badge { font-size: 7pt; font-weight: 800; padding: 1px 5px; letter-spacing: 1.5px; text-transform: uppercase; display: inline-block; margin-bottom: 2px; }
  .print-badge.high { background: #8b2a2a; color: white; }
  .print-badge.medium { background: #d4941a; color: white; }
  .print-badge.low { background: #2e7d7a; color: white; }

  /* Stat row */
  .print-stat-row { display: flex; align-items: center; gap: 6px; padding: 3px 0; border-bottom: 0.5px solid #eee; }
  .print-stat-row:last-child { border-bottom: none; }
  .print-stat-label { font-size: 8.5pt; color: #555; width: 110px; flex-shrink: 0; }
  .print-stat-bar { flex: 1; height: 6px; background: #eee; border-radius: 2px; overflow: hidden; }
  .print-stat-fill { height: 100%; border-radius: 2px; }
  .print-stat-val { font-size: 9pt; font-weight: 800; width: 32px; text-align: right; flex-shrink: 0; }

  /* Player attribute grid */
  .print-attr-grid { display: grid; grid-template-columns: repeat(6, 1fr); gap: 3px; }
  .print-attr { text-align: center; border: 1px solid #ddd; padding: 3px; }
  .print-attr-label { font-size: 6.5pt; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; color: #888; }
  .print-attr-val { font-size: 11pt; font-weight: 900; }

  /* Formation display */
  .print-formation-wrap { background: #2d6035; height: 180px; position: relative; border: 2px solid #1a1612; margin-bottom: 8px; }
  .print-formation-token {
    position: absolute; transform: translate(-50%, -50%);
    width: 30px; height: 30px; border-radius: 50%;
    border: 2px solid white; display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    font-size: 6pt; font-weight: 800; color: white;
  }

  /* Team talk box */
  .print-team-talk { background: #1a1612; color: white; padding: 10px 12px; break-inside: avoid; }
  .print-team-talk-title { font-size: 7pt; font-weight: 800; letter-spacing: 3px; text-transform: uppercase; color: #d4941a; margin-bottom: 5px; }
  .print-team-talk-text { font-size: 10pt; line-height: 1.65; font-style: italic; }

  /* Week plan */
  .print-day { border: 1.5px solid #ddd; padding: 6px 8px; break-inside: avoid; }
  .print-day-label { font-size: 7pt; font-weight: 800; letter-spacing: 2px; text-transform: uppercase; color: #888; }
  .print-day-theme { font-size: 9.5pt; font-weight: 800; color: #1a1612; margin: 1px 0; }
  .print-day-drills { font-size: 8.5pt; color: #444; }

  /* Footer */
  .print-footer {
    position: fixed; bottom: 0; left: 0; right: 0;
    border-top: 1px solid #ddd; padding: 4px 16mm;
    display: flex; justify-content: space-between;
    font-size: 7pt; color: #aaa;
  }

  /* Page break helpers */
  .page-break { break-before: page; }
  .no-break { break-inside: avoid; }

  @media print {
    .no-print { display: none !important; }
  }
`;

/* ── Open a print window with HTML content ── */
function openPrintWindow(title, html) {
  const w = window.open("", "_blank", "width=900,height=700");
  if (!w) {
    alert("Pop-up blocked. Please allow pop-ups for this site to export PDFs.");
    return;
  }
  w.document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${title} — Footy Analyst</title>
  <style>${PRINT_CSS}</style>
</head>
<body>
${html}
<div class="print-footer">
  <span>Footy Analyst · footyanalyst.co.uk</span>
  <span>${title}</span>
  <span>${new Date().toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"})}</span>
</div>
<div class="no-print" style="position:fixed;top:12px;right:12px;display:flex;gap:8px;z-index:9999">
  <button onclick="window.print()" style="padding:10px 22px;background:#2e7d7a;color:white;border:none;font-family:Arial;font-weight:800;font-size:12px;letter-spacing:1px;text-transform:uppercase;cursor:pointer;">
    🖨 Print / Save PDF
  </button>
  <button onclick="window.close()" style="padding:10px 16px;background:#1a1612;color:white;border:none;font-family:Arial;font-weight:800;font-size:11px;cursor:pointer;">
    ✕ Close
  </button>
</div>
</body>
</html>`);
  w.document.close();
}

/* ── Shared header ── */
function printHeader(title, subtitle, meta = []) {
  return `
    <div class="print-header">
      <div>
        <div class="print-brand">Footy Analyst · Football Intelligence</div>
        <div class="print-doc-title">${title}</div>
        ${subtitle ? `<div class="print-doc-sub">${subtitle}</div>` : ""}
      </div>
      <div class="print-meta">
        ${meta.map(m => `<div><strong>${m.label}:</strong> ${m.value}</div>`).join("")}
        <div>Generated: ${new Date().toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>
      </div>
    </div>
  `;
}

/* ─────────────────────────────────────────
   EXPORT 1: OPPOSITION DOSSIER
───────────────────────────────────────── */
export function exportDossierPDF(dossier, squad = []) {
  if (!dossier) return;
  const d = dossier.data;
  const OPP_STYLES_MAP = {
    "high-press":"High Press","possession":"Possession Play","counter":"Counter-attack",
    "low-block":"Low Block","direct":"Direct & Physical","hybrid":"Flexible/Hybrid",
    "3-5-2":"3-5-2 Wing Play","4-4-2":"4-4-2 Physical","tiki-taka":"Tiki-Taka","route-one":"Route One",
  };

  const threatsHtml = d.threats.map(t => `
    <div class="print-card ${t.level==="high"?"danger":t.level==="medium"?"warning":""}">
      <div><span class="print-badge ${t.level}">${t.level}</span></div>
      <div class="print-card-title">${t.title}</div>
      <div class="print-card-sub">${t.desc}</div>
      ${t.instruction ? `<div style="font-size:8.5pt;font-weight:700;color:#2e7d7a;margin-top:3px;">→ ${t.instruction}</div>` : ""}
    </div>
  `).join("");

  const weekPlanHtml = (d.weekPlan||[]).map(w => `
    <div class="print-day">
      <div class="print-day-label">${w.day}</div>
      <div class="print-day-theme">${w.theme}</div>
      <div class="print-day-drills">${(w.drills||[]).join(" · ")}</div>
      ${w.note ? `<div style="font-size:8pt;color:#888;margin-top:2px;font-style:italic;">${w.note}</div>` : ""}
    </div>
  `).join("");

  const battlesHtml = (d.keyBattles||[]).slice(0,4).map(b => `
    <div class="print-card accent">
      <div class="print-card-title">${b.ourPlayer} vs ${b.theirPlayer}</div>
      <div class="print-card-sub">${b.ourRole} · ${b.instruction}</div>
      ${b.themThreat ? `<div style="font-size:8pt;color:#8b2a2a;margin-top:2px;">Watch: ${b.themThreat}</div>` : ""}
    </div>
  `).join("");

  const html = `
    ${printHeader(
      `Opposition Dossier — ${dossier.oppName}`,
      `${dossier.competition||"Match"} · ${dossier.matchDate||"Date TBD"} · ${dossier.venue==="home"?"Home":"Away"}`,
      [
        {label:"Formation",value:dossier.oppForm||"Unknown"},
        {label:"Style",value:OPP_STYLES_MAP[dossier.oppStyle]||dossier.oppStyle},
      ]
    )}

    <div class="print-cols">
      <div>
        <div class="print-section">
          <div class="print-section-title">Their Principles</div>
          <ul class="print-list">
            ${(d.theirPrinciples||[]).map(p=>`<li class="bullet">${p}</li>`).join("")}
          </ul>
        </div>
        <div class="print-section">
          <div class="print-section-title">Our Defensive Instructions</div>
          <ul class="print-list">
            ${(d.defensiveInstructions||[]).map(i=>`<li>${i}</li>`).join("")}
          </ul>
        </div>
        <div class="print-section">
          <div class="print-section-title">Our Attacking Instructions</div>
          <ul class="print-list">
            ${(d.attackingInstructions||[]).map(i=>`<li>${i}</li>`).join("")}
          </ul>
        </div>
        ${d.setPieceNotes ? `
          <div class="print-section">
            <div class="print-section-title">Set Piece Notes</div>
            <ul class="print-list">
              ${(d.setPieceNotes||[]).map(n=>`<li class="bullet">${n}</li>`).join("")}
            </ul>
          </div>
        ` : ""}
      </div>
      <div>
        <div class="print-section">
          <div class="print-section-title">Key Threats</div>
          ${threatsHtml}
        </div>
        ${battlesHtml ? `
          <div class="print-section">
            <div class="print-section-title">Key Battles</div>
            ${battlesHtml}
          </div>
        ` : ""}
      </div>
    </div>

    ${d.matchdayMessage ? `
      <div class="print-team-talk no-break">
        <div class="print-team-talk-title">Match Day Message</div>
        <div class="print-team-talk-text">${d.matchdayMessage}</div>
      </div>
    ` : ""}

    ${weekPlanHtml ? `
      <div class="print-section page-break">
        <div class="print-section-title">4-Day Preparation Plan</div>
        <div class="print-cols-3" style="margin-top:6px;">${weekPlanHtml}</div>
      </div>
    ` : ""}

    ${squad.length > 0 ? `
      <div class="print-section no-break">
        <div class="print-section-title">Individual Player Briefings</div>
        <div class="print-cols">
          ${squad.slice(0,12).map((p,i) => {
            const battle = (d.keyBattles||[])[i%(d.keyBattles||[{themThreat:"Stay alert",instruction:"Track your runner"}]).length] || {};
            return `
              <div class="print-card">
                <div class="print-card-title">${p.name} (${p.pos})</div>
                <div class="print-card-sub">${battle.instruction||"Focus on your defensive duties"}</div>
                ${battle.themThreat ? `<div style="font-size:8pt;color:#8b2a2a;">Watch: ${battle.themThreat}</div>` : ""}
              </div>
            `;
          }).join("")}
        </div>
      </div>
    ` : ""}
  `;

  openPrintWindow(`Dossier — ${dossier.oppName}`, html);
}

/* ─────────────────────────────────────────
   EXPORT 2: MATCH PREP REPORT
───────────────────────────────────────── */
export function exportMatchPrepPDF(fixture, squad = []) {
  if (!fixture) return;

  const loadData = loadFromStorage("load_management", {}) || {};
  const availPlayers = squad.filter(p => {
    const d = loadData[p.id];
    return !d || d.status === "available";
  });
  const unavailPlayers = squad.filter(p => {
    const d = loadData[p.id];
    return d && d.status !== "available";
  });

  const prepItems = [
    {key:"dossier",   label:"Opposition Dossier"},
    {key:"tactics",   label:"Tactical Plan"},
    {key:"training",  label:"Training Session"},
    {key:"setpieces", label:"Set Piece Routines"},
    {key:"teamTalk",  label:"Team Talk"},
  ];
  const prep = fixture.prep || {};
  const prepDone = prepItems.filter(i => prep[i.key]).length;

  const daysUntil = Math.ceil((new Date(fixture.date) - new Date()) / (1000*60*60*24));

  const html = `
    ${printHeader(
      `Match Prep — vs ${fixture.opponent}`,
      `${fixture.competition} · ${fixture.venue === "home" ? "Home" : "Away"} · ${new Date(fixture.date).toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long"})} · KO ${fixture.kickoff}`,
      [
        {label:"Days Away", value: daysUntil >= 0 ? `${daysUntil} days` : "Today"},
        {label:"Prep", value: `${prepDone}/5 complete`},
        {label:"Available", value: `${availPlayers.length}/${squad.length} players`},
      ]
    )}

    <div class="print-cols">
      <div>
        <div class="print-section">
          <div class="print-section-title">Preparation Checklist</div>
          <ul class="print-list">
            ${prepItems.map(i => `<li class="${prep[i.key] ? "check" : "cross"}">${i.label}</li>`).join("")}
          </ul>
        </div>

        ${unavailPlayers.length > 0 ? `
          <div class="print-section">
            <div class="print-section-title">Injury / Availability Concerns</div>
            ${unavailPlayers.map(p => {
              const d = loadData[p.id] || {};
              return `
                <div class="print-card ${d.status === "injured" ? "danger" : "warning"}">
                  <div class="print-card-title">${p.name} (${p.pos})</div>
                  <div class="print-card-sub">${d.injuryType || d.status || "Unavailable"} ${d.returnDate ? `· Expected back: ${new Date(d.returnDate).toLocaleDateString("en-GB",{day:"numeric",month:"short"})}` : ""}</div>
                </div>
              `;
            }).join("")}
          </div>
        ` : `
          <div class="print-section">
            <div class="print-section-title">Squad Availability</div>
            <div class="print-card good">
              <div class="print-card-title">✓ Full squad available</div>
              <div class="print-card-sub">No injury concerns for this fixture</div>
            </div>
          </div>
        `}

        ${fixture.notes ? `
          <div class="print-section">
            <div class="print-section-title">Match Notes</div>
            <div class="print-card">${fixture.notes}</div>
          </div>
        ` : ""}
      </div>

      <div>
        <div class="print-section">
          <div class="print-section-title">Available Squad (${availPlayers.length})</div>
          ${availPlayers.map(p => `
            <div class="print-stat-row">
              <div class="print-stat-label">${p.name}</div>
              <div style="font-size:8pt;font-weight:800;color:#2e7d7a;width:32px;text-align:center;">${p.pos}</div>
              <div style="font-size:8pt;color:#888;">OVR ${p.overall || 70}</div>
            </div>
          `).join("")}
        </div>
      </div>
    </div>

    <div style="margin-top:16px;border:2px solid #1a1612;padding:10px;">
      <div style="font-size:7pt;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#888;margin-bottom:6px;">Team Talk Notes</div>
      <div style="height:80px;border-bottom:0.5px solid #ddd;"></div>
      <div style="height:80px;border-bottom:0.5px solid #ddd;margin-top:8px;"></div>
    </div>
  `;

  openPrintWindow(`Match Prep — ${fixture.opponent}`, html);
}

/* ─────────────────────────────────────────
   EXPORT 3: SESSION / TRAINING PLAN
───────────────────────────────────────── */
export function exportSessionPDF(drills, sessionInfo = {}) {
  if (!drills || drills.length === 0) return;

  const totalDuration = drills.reduce((s, d) => s + parseInt(d.duration || "20"), 0);

  const html = `
    ${printHeader(
      sessionInfo.title || "Training Session Plan",
      sessionInfo.theme || `${drills.length} drill${drills.length !== 1 ? "s" : ""} · ${totalDuration} minutes`,
      [
        {label:"Date", value: sessionInfo.date || new Date().toLocaleDateString("en-GB")},
        {label:"Players", value: sessionInfo.players || "Full squad"},
        {label:"Focus", value: sessionInfo.focus || "As below"},
      ]
    )}

    ${sessionInfo.objectives ? `
      <div class="print-card accent" style="margin-bottom:12px;">
        <div class="print-card-title">Session Objectives</div>
        <div class="print-card-sub">${sessionInfo.objectives}</div>
      </div>
    ` : ""}

    <table style="width:100%;border-collapse:collapse;margin-bottom:14px;">
      <thead>
        <tr style="background:#1a1612;color:white;">
          <th style="padding:5px 8px;text-align:left;font-size:7.5pt;letter-spacing:2px;text-transform:uppercase;width:30px;">#</th>
          <th style="padding:5px 8px;text-align:left;font-size:7.5pt;letter-spacing:2px;text-transform:uppercase;">Drill</th>
          <th style="padding:5px 8px;text-align:left;font-size:7.5pt;letter-spacing:2px;text-transform:uppercase;width:80px;">Focus</th>
          <th style="padding:5px 8px;text-align:left;font-size:7.5pt;letter-spacing:2px;text-transform:uppercase;width:55px;">Duration</th>
          <th style="padding:5px 8px;text-align:left;font-size:7.5pt;letter-spacing:2px;text-transform:uppercase;width:60px;">Intensity</th>
        </tr>
      </thead>
      <tbody>
        ${drills.map((d, i) => `
          <tr style="border-bottom:1px solid #eee;${i%2===0?"background:#fafafa":""};">
            <td style="padding:6px 8px;font-weight:800;font-size:9pt;color:#888;">${i+1}</td>
            <td style="padding:6px 8px;">
              <div style="font-weight:800;font-size:9.5pt;color:#1a1612;">${d.title}</div>
              ${d.desc ? `<div style="font-size:8.5pt;color:#555;margin-top:1px;">${d.desc}</div>` : ""}
              ${d.players ? `<div style="font-size:8pt;color:#2e7d7a;margin-top:1px;">Players: ${d.players}</div>` : ""}
            </td>
            <td style="padding:6px 8px;font-size:8.5pt;color:#444;">${d.focus||d.tactical||"—"}</td>
            <td style="padding:6px 8px;font-size:8.5pt;font-weight:700;">${d.duration||"20 min"}</td>
            <td style="padding:6px 8px;">
              <span style="font-size:7pt;font-weight:800;padding:1px 5px;text-transform:uppercase;letter-spacing:1px;${
                (d.intensity||"").toLowerCase()==="high"||d.intensity==="Very High"?"background:#8b2a2a;color:white":
                (d.intensity||"").toLowerCase()==="medium"?"background:#d4941a;color:white":
                "background:#2e7d7a;color:white"
              };">${d.intensity||"Med"}</span>
            </td>
          </tr>
        `).join("")}
      </tbody>
    </table>

    <div class="print-cols" style="margin-top:12px;">
      <div>
        <div style="font-size:7pt;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#888;margin-bottom:6px;">Coaching Points</div>
        <div style="height:70px;border-bottom:0.5px solid #ddd;"></div>
        <div style="height:70px;border-bottom:0.5px solid #ddd;margin-top:8px;"></div>
      </div>
      <div>
        <div style="font-size:7pt;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#888;margin-bottom:6px;">Session Notes</div>
        <div style="height:70px;border-bottom:0.5px solid #ddd;"></div>
        <div style="height:70px;border-bottom:0.5px solid #ddd;margin-top:8px;"></div>
      </div>
    </div>

    <div style="margin-top:12px;text-align:center;font-size:8pt;color:#888;border-top:1px solid #eee;padding-top:6px;">
      Total session: ${totalDuration} minutes · ${drills.length} drills
    </div>
  `;

  openPrintWindow(sessionInfo.title || "Training Session", html);
}

/* ─────────────────────────────────────────
   EXPORT 4: SQUAD LIST
───────────────────────────────────────── */
export function exportSquadPDF(squad, clubName = "My Club") {
  if (!squad || squad.length === 0) return;

  const byGroup = {
    gk: squad.filter(p => p.group === "gk" || p.pos === "GK"),
    def: squad.filter(p => p.group === "def"),
    mid: squad.filter(p => p.group === "mid"),
    att: squad.filter(p => p.group === "att"),
  };

  const groupLabel = { gk: "Goalkeepers", def: "Defenders", mid: "Midfielders", att: "Attackers" };
  const groupColor = { gk: "#b45309", def: "#8b2a2a", mid: "#2e7d7a", att: "#16a34a" };

  const attrColor = (v) => v >= 80 ? "#16a34a" : v >= 65 ? "#d4941a" : "#8b2a2a";

  const html = `
    ${printHeader(
      `Squad List — ${clubName}`,
      `${squad.length} players registered · ${new Date().getFullYear()}/25 Season`,
      [
        {label:"Avg OVR", value: Math.round(squad.reduce((s,p)=>s+(p.overall||70),0)/squad.length)},
        {label:"GK", value: byGroup.gk.length},
        {label:"DEF", value: byGroup.def.length},
        {label:"MID", value: byGroup.mid.length},
        {label:"ATT", value: byGroup.att.length},
      ]
    )}

    ${Object.entries(byGroup).filter(([,players]) => players.length > 0).map(([group, players]) => `
      <div class="print-section">
        <div class="print-section-title" style="color:${groupColor[group]};border-color:${groupColor[group]};">${groupLabel[group]} (${players.length})</div>
        <table style="width:100%;border-collapse:collapse;font-size:8.5pt;">
          <thead>
            <tr style="background:#f5f5f5;">
              <th style="padding:3px 6px;text-align:left;font-size:7pt;letter-spacing:1.5px;text-transform:uppercase;color:#888;font-weight:800;">Name</th>
              <th style="padding:3px 6px;text-align:center;width:30px;font-size:7pt;letter-spacing:1.5px;text-transform:uppercase;color:#888;font-weight:800;">POS</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">Age</th>
              <th style="padding:3px 6px;text-align:center;width:30px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">OVR</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">PAC</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">SHO</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">PAS</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">DRI</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">DEF</th>
              <th style="padding:3px 6px;text-align:center;width:24px;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">PHY</th>
              <th style="padding:3px 6px;text-align:left;font-size:7pt;text-transform:uppercase;color:#888;font-weight:800;">Style</th>
            </tr>
          </thead>
          <tbody>
            ${players.map((p, i) => `
              <tr style="border-bottom:0.5px solid #eee;${i%2===0?"background:#fafafa":""};">
                <td style="padding:4px 6px;font-weight:700;">${p.name}</td>
                <td style="padding:4px 6px;text-align:center;font-weight:800;font-size:7.5pt;color:${groupColor[group]};">${p.pos}</td>
                <td style="padding:4px 6px;text-align:center;color:#666;">${p.age||"—"}</td>
                <td style="padding:4px 6px;text-align:center;font-weight:900;font-size:10pt;">${p.overall||70}</td>
                ${["pace","shooting","passing","dribbling","defending","physical"].map(a => `
                  <td style="padding:4px 6px;text-align:center;font-weight:700;color:${attrColor(p[a]||70)};">${p[a]||70}</td>
                `).join("")}
                <td style="padding:4px 6px;color:#666;font-size:8pt;">${p.style||"—"}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
    `).join("")}
  `;

  openPrintWindow(`Squad — ${clubName}`, html);
}

/* ─────────────────────────────────────────
   EXPORT 5: SET PIECE ROUTINE
───────────────────────────────────────── */
export function exportSetPiecePDF(routine) {
  if (!routine) return;

  const RUNNER_STYLES = {
    "near-post":  {label:"Near Post Run",   color:"#FFD700"},
    "far-post":   {label:"Far Post Run",    color:"#4ade80"},
    "penalty":    {label:"Penalty Spot",    color:"#f87171"},
    "edge":       {label:"Edge of Box",     color:"#60a5fa"},
    "flick-on":   {label:"Flick-on",        color:"#c084fc"},
    "blocker":    {label:"Blocker",         color:"#fb923c"},
    "recycler":   {label:"Recycle",         color:"#a3e635"},
    "goalkeeper": {label:"GK Position",     color:"#94a3b8"},
  };

  const html = `
    ${printHeader(
      routine.name || "Set Piece Routine",
      `${routine.type?.replace("-"," ").replace(/\b\w/g, l => l.toUpperCase()) || "Corner"} · ${routine.mode === "attack" ? "Attacking" : "Defensive"}`,
      [
        {label:"Delivery Zone", value: routine.deliveryZone || "Not specified"},
        {label:"Runners", value: routine.tokens?.length || 0},
      ]
    )}

    <div class="print-cols">
      <div>
        <div class="print-section">
          <div class="print-section-title">Runner Assignments</div>
          ${(routine.tokens||[]).map(t => {
            const style = RUNNER_STYLES[t.type] || {label: t.type, color: "#888"};
            return `
              <div class="print-card" style="border-left:4px solid ${style.color};">
                <div class="print-card-title">#${t.num} ${t.name || "Player"}</div>
                <div class="print-card-sub" style="color:${style.color};font-weight:700;">${style.label}</div>
                <div style="font-size:8pt;color:#555;margin-top:2px;">Position: ${Math.round(t.x)}% x ${Math.round(t.y)}%</div>
              </div>
            `;
          }).join("")}
        </div>
      </div>
      <div>
        ${routine.desc ? `
          <div class="print-section">
            <div class="print-section-title">Routine Notes</div>
            <div class="print-card">${routine.desc}</div>
          </div>
        ` : ""}
        <div class="print-section">
          <div class="print-section-title">Key Instructions</div>
          <ul class="print-list">
            <li>Delivery zone: ${routine.deliveryZone || "Coach instruction"}</li>
            <li>${(routine.tokens||[]).length} runners assigned — rehearse timing in training</li>
            <li>Review video of opponent defending set pieces</li>
            <li>Practice at match tempo — not walking pace</li>
          </ul>
        </div>
        <div style="margin-top:12px;border:1.5px solid #ddd;padding:8px;">
          <div style="font-size:7pt;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#888;margin-bottom:6px;">Coach Notes</div>
          <div style="height:80px;"></div>
        </div>
      </div>
    </div>
  `;

  openPrintWindow(routine.name || "Set Piece Routine", html);
}

/* ─────────────────────────────────────────
   EXPORT BUTTON COMPONENT — reusable
───────────────────────────────────────── */
/* ─────────────────────────────────────────
   EXPORT 6: PRE-MATCH PACK
   The full document a manager hands to players
   before a match — formation, tactics, opposition
   summary, individual instructions, set pieces, team talk
───────────────────────────────────────── */
export function exportPreMatchPack({ fixture, squad = [], formation = "4-3-3", tacticsState = null, dossier = null, clubName = "My Club", profile = {} }) {
  const loadData = loadFromStorage("load_management", {}) || {};
  const setpieces = loadFromStorage("set_piece_routines", []) || [];
  const boardState = tacticsState || loadFromStorage("tactics_board_state", null);
  const currentSystem = boardState?.currentSystem;

  // Availability
  const available  = squad.filter(p => !loadData[p.id] || loadData[p.id].status === "Available");
  const unavailable = squad.filter(p => loadData[p.id]?.status === "injured" || loadData[p.id]?.status === "suspended");
  const doubtful   = squad.filter(p => loadData[p.id]?.status === "doubtful");

  // Formation diagram tokens
  const tokens = boardState?.tokens || [];
  const formationDiagram = tokens.length > 0 ? `
    <div class="print-formation-wrap">
      ${tokens.filter(t=>t.team!=="b").map(t => {
        const x = t.x;
        const y = 100 - t.y; // flip for print (attacking up)
        const playerName = t.player ? t.player.name.split(" ").slice(-1)[0] : t.pos;
        return `
          <div class="print-formation-token" style="left:${x}%;top:${y}%;background:#2e7d7a;">
            <div style="font-size:5.5pt;font-weight:900;">${t.pos}</div>
            <div style="font-size:4.5pt;font-weight:600;opacity:0.85;">${playerName}</div>
          </div>`;
      }).join("")}
    </div>
  ` : `
    <div style="background:#2d6035;height:120px;display:flex;align-items:center;justify-content:center;border:2px solid #1a1612;margin-bottom:8px;">
      <div style="color:rgba(255,255,255,0.5);font-size:9pt;font-style:italic;">${formation}</div>
    </div>
  `;

  // System principles
  const principles = currentSystem?.principles || boardState?.systemPrinciples || [];

  // Dossier data
  const d = dossier?.data;
  const oppName = fixture?.opponent || dossier?.oppName || "Opposition";
  const oppForm = fixture?.oppFormation || dossier?.oppForm || "";

  // Set piece summary
  const attackSetPieces = setpieces.filter(sp => sp.type === "corner" || sp.type === "freekick").slice(0, 3);

  const html = `
    ${printHeader(
      `Pre-Match Pack — ${oppName}`,
      `${fixture?.competition||"Match"} · ${fixture?.date ? new Date(fixture.date).toLocaleDateString("en-GB",{weekday:"short",day:"numeric",month:"long"}) : "Date TBD"} · ${fixture?.kickoff||""} · ${fixture?.venue==="home"?"Home":"Away"}`,
      [
        {label:"Club", value: clubName},
        {label:"Formation", value: formation},
        {label:"Manager", value: profile?.name || ""},
      ].filter(m=>m.value)
    )}

    <!-- PAGE 1: TACTICS & AVAILABILITY -->
    <div class="print-cols">
      <div>
        <!-- Formation -->
        <div class="print-section">
          <div class="print-section-title">Our Shape — ${formation}${currentSystem ? ` · ${currentSystem.name||""}` : ""}</div>
          ${formationDiagram}
        </div>

        ${principles.length > 0 ? `
          <div class="print-section">
            <div class="print-section-title">Tactical Principles</div>
            <ul class="print-list">
              ${principles.slice(0,6).map(p=>`<li class="bullet">${p}</li>`).join("")}
            </ul>
          </div>
        ` : ""}
      </div>

      <div>
        <!-- Squad availability -->
        <div class="print-section">
          <div class="print-section-title">Squad Availability</div>
          ${available.slice(0,16).map(p => {
            const rating = (() => {
              const ratings = loadFromStorage("player_match_ratings",[]) || [];
              const playerRatings = ratings.flatMap(m => m.ratings?.[p.id] ? [m.ratings[p.id]] : []).slice(0,5);
              return playerRatings.length > 0 ? (playerRatings.reduce((s,r)=>s+r,0)/playerRatings.length).toFixed(1) : null;
            })();
            return `
              <div class="print-stat-row">
                <div style="font-size:8.5pt;font-weight:700;width:26px;flex-shrink:0;color:#555;">${p.pos}</div>
                <div style="font-size:9pt;font-weight:700;flex:1;">${p.name}</div>
                ${rating ? `<div style="font-size:8pt;font-weight:800;color:${Number(rating)>=7?"#2e7d7a":Number(rating)>=6?"#d4941a":"#8b2a2a"};width:28px;text-align:right;">${rating}</div>` : ""}
              </div>
            `;
          }).join("")}
          ${unavailable.length > 0 ? `
            <div style="margin-top:6px;padding-top:5px;border-top:1px solid #eee;">
              <div style="font-size:7pt;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:#8b2a2a;margin-bottom:3px;">Unavailable</div>
              ${unavailable.map(p=>`<div style="font-size:8.5pt;color:#8b2a2a;padding:1.5px 0;">${p.name} · ${loadData[p.id]?.status||"Out"}</div>`).join("")}
            </div>
          ` : ""}
          ${doubtful.length > 0 ? `
            <div style="margin-top:5px;padding-top:5px;border-top:1px solid #eee;">
              <div style="font-size:7pt;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:#d4941a;margin-bottom:3px;">Doubtful</div>
              ${doubtful.map(p=>`<div style="font-size:8.5pt;color:#d4941a;padding:1.5px 0;">${p.name}</div>`).join("")}
            </div>
          ` : ""}
        </div>
      </div>
    </div>

    ${d ? `
    <!-- PAGE 2: OPPOSITION INTELLIGENCE -->
    <div class="page-break">
      ${printHeader(`Opposition — ${oppName}`, `${oppForm ? `${oppForm} · ` : ""}${dossier?.oppStyle || ""}`, [])}

      <div class="print-cols">
        <div>
          ${d.theirPrinciples ? `
            <div class="print-section">
              <div class="print-section-title">How They Play</div>
              <ul class="print-list">
                ${d.theirPrinciples.slice(0,5).map(p=>`<li class="bullet">${p}</li>`).join("")}
              </ul>
            </div>
          ` : ""}
          <div class="print-section">
            <div class="print-section-title">Our Defensive Instructions</div>
            <ul class="print-list">
              ${(d.defensiveInstructions||[]).slice(0,5).map(i=>`<li>${i}</li>`).join("")}
            </ul>
          </div>
          <div class="print-section">
            <div class="print-section-title">Our Attacking Instructions</div>
            <ul class="print-list">
              ${(d.attackingInstructions||[]).slice(0,5).map(i=>`<li>${i}</li>`).join("")}
            </ul>
          </div>
        </div>
        <div>
          ${d.threats ? `
            <div class="print-section">
              <div class="print-section-title">Key Threats</div>
              ${d.threats.slice(0,3).map(t=>`
                <div class="print-card ${t.level==="high"?"danger":t.level==="medium"?"warning":""}">
                  <span class="print-badge ${t.level}">${t.level}</span>
                  <div class="print-card-title">${t.title}</div>
                  <div class="print-card-sub">${t.desc}</div>
                  ${t.instruction?`<div style="font-size:8pt;font-weight:700;color:#2e7d7a;margin-top:2px;">→ ${t.instruction}</div>`:""}
                </div>
              `).join("")}
            </div>
          ` : ""}
          ${d.keyBattles ? `
            <div class="print-section">
              <div class="print-section-title">Key Battles</div>
              ${d.keyBattles.slice(0,3).map(b=>`
                <div class="print-card accent">
                  <div class="print-card-title">${b.ourPlayer} vs ${b.theirPlayer}</div>
                  <div class="print-card-sub">${b.instruction}</div>
                  ${b.themThreat?`<div style="font-size:8pt;color:#8b2a2a;">Watch: ${b.themThreat}</div>`:""}
                </div>
              `).join("")}
            </div>
          ` : ""}
          ${d.setPieceNotes ? `
            <div class="print-section">
              <div class="print-section-title">Set Piece Notes</div>
              <ul class="print-list">
                ${(d.setPieceNotes||[]).map(n=>`<li class="bullet">${n}</li>`).join("")}
              </ul>
            </div>
          ` : ""}
        </div>
      </div>
    </div>
    ` : ""}

    ${attackSetPieces.length > 0 ? `
    <!-- SET PIECES -->
    <div class="${d?"":"page-break"}">
      <div class="print-section">
        <div class="print-section-title">Our Set Piece Routines</div>
        <div class="print-cols-3">
          ${attackSetPieces.map(sp=>`
            <div class="print-card">
              <div class="print-card-title">${sp.name||sp.type}</div>
              <div class="print-card-sub">${sp.description||""}</div>
              ${sp.players ? `<div style="font-size:7.5pt;color:#555;margin-top:3px;">${sp.players}</div>` : ""}
            </div>
          `).join("")}
        </div>
      </div>
    </div>
    ` : ""}

    <!-- TEAM TALK -->
    ${d?.matchdayMessage ? `
    <div class="print-team-talk no-break" style="${(d||attackSetPieces.length)?"":"margin-top:16px;"}">
      <div class="print-team-talk-title">Manager's Message — vs ${oppName}</div>
      <div class="print-team-talk-text">${d.matchdayMessage}</div>
    </div>
    ` : ""}

    <!-- INDIVIDUAL INSTRUCTIONS (if squad > 0 and battles exist) -->
    ${squad.length > 0 && d?.keyBattles ? `
    <div class="print-section page-break">
      <div class="print-section-title">Individual Player Instructions</div>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;">
        ${squad.slice(0,12).map((p,i) => {
          const battle = (d.keyBattles||[])[i%(d.keyBattles||[]).length] || {};
          return `
            <div class="print-card">
              <div style="display:flex;justify-content:space-between;align-items:baseline;">
                <div class="print-card-title">${p.name}</div>
                <div style="font-size:7.5pt;color:#888;">${p.pos}</div>
              </div>
              <div class="print-card-sub">${battle.instruction||"Maintain your position and shape"}</div>
              ${battle.themThreat ? `<div style="font-size:7.5pt;color:#8b2a2a;margin-top:2px;">Watch: ${battle.themThreat}</div>` : ""}
            </div>
          `;
        }).join("")}
      </div>
    </div>
    ` : ""}
  `;

  openPrintWindow(`Pre-Match Pack — ${oppName}`, html);
}

export function ExportButton({ onClick, label = "Export PDF", small = false }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: small ? "0.32rem 0.75rem" : "0.52rem 1.1rem",
        background: "var(--ink)",
        color: "var(--white)",
        border: "2px solid var(--ink)",
        fontFamily: "'DM Sans',sans-serif",
        fontWeight: 800,
        fontSize: small ? "0.6rem" : "0.68rem",
        letterSpacing: "1.5px",
        textTransform: "uppercase",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem",
        transition: "all 0.2s",
        flexShrink: 0,
      }}
      onMouseEnter={e => { e.currentTarget.style.background = "var(--teal)"; e.currentTarget.style.borderColor = "var(--teal)"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "var(--ink)"; e.currentTarget.style.borderColor = "var(--ink)"; }}
    >
      🖨 {label}
    </button>
  );
}
